import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es un producto 100% digital. No recibirás nada físico en tu domicilio. Todo el contenido se descarga en formato PDF.'
}, {
  q: '¿Cómo recibo el Pack?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace de acceso y descarga a toda la biblioteca.'
}, {
  q: '¿Tengo acceso para siempre?',
  a: 'Sí, pagás una sola vez y el acceso es de por vida. Podés descargar los archivos o consultarlos online cuando quieras.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El pack incluye desde manuales para principiantes hasta textos avanzados. Es ideal tanto para empezar de cero como para profundizar.'
}, {
  q: '¿Sirve si ya soy terapeuta?',
  a: 'Absolutamente. Encontrarás herramientas, protocolos y disciplinas nuevas para sumar a tus terapias y ofrecer más valor a tus consultantes.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí, todos los archivos están en formato PDF, compatibles con cualquier celular, tablet o computadora.'
}, {
  q: '¿Incluye los bonus?',
  a: 'Sí, si comprás hoy durante esta oferta especial, los 3 bonus detallados se incluyen totalmente gratis en tu descarga.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es automático e inmediato tras la confirmación del pago, sin importar el día o la hora.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 bg-white" data-id="element-94">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif font-bold text-center text-black mb-8" data-id="element-96">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-2" data-id="element-97">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border-b border-gray-200" data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between py-4 text-left focus:outline-none" data-id="element-99">
                <span className="font-medium text-gray-900 pr-4 text-sm md:text-base" data-id="element-100">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-101" />
              </button>
              <AnimatePresence data-id="element-102">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-103">
                    <div className="pb-4 text-gray-600 text-sm leading-relaxed" data-id="element-104">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}